import React from 'react';
import { defineMessages } from 'react-intl-next';

import {
	useLivePageReleasePhase,
	LivePageReleasePhase,
} from '@confluence/live-pages-release-manager/entry-points/useLivePageReleasePhase';

import { FeatureLozenge, type FeatureLozengeProps } from './FeatureLozenge';

const i18n = defineMessages({
	livePageLozengeText: {
		id: 'live-pages-features.live-edit-lozenge.label',
		defaultMessage: 'Live',
		description:
			'Lozenge indicating the live page feature which allows for real time edit of pages without needing to publish',
	},
	betalivePageLozengeText: {
		id: 'live-pages-features.live-edit-lozenge.beta.label',
		defaultMessage: 'Beta',
		description:
			'Lozenge indicating the live page feature which allows for real time edit of pages without needing to publish is in beta',
	},
});

export type LivePagesFeatureLozengeProps = Pick<FeatureLozengeProps, 'showIcon'>;

export const LivePagesFeatureLozenge = ({ showIcon = false }: LivePagesFeatureLozengeProps) => {
	const livePageReleasePhase = useLivePageReleasePhase();
	const isBetaReleaseWithLivePagesOn =
		livePageReleasePhase === LivePageReleasePhase.OPEN_BETA_DEFAULT_ON ||
		livePageReleasePhase === LivePageReleasePhase.OPEN_BETA_DEFAULT_OFF;

	const message = isBetaReleaseWithLivePagesOn
		? i18n.betalivePageLozengeText
		: i18n.livePageLozengeText;

	return <FeatureLozenge showIcon={showIcon} message={message} testId="live-pages-lozenge" />;
};
